// extracted by mini-css-extract-plugin
export var footer = "_s1-0";
export var inherit = "_s1-1";
export var input = "_s1-2";
export var modalContent = "_s1-3";
export var quillEditor = "_s1-4";
export var subtitle = "_s1-5";